import { render, staticRenderFns } from "./self.vue?vue&type=template&id=a8b23ef2&scoped=true&"
import script from "./self.vue?vue&type=script&lang=js&"
export * from "./self.vue?vue&type=script&lang=js&"
import style0 from "./self.vue?vue&type=style&index=0&id=a8b23ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b23ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8b23ef2')) {
      api.createRecord('a8b23ef2', component.options)
    } else {
      api.reload('a8b23ef2', component.options)
    }
    module.hot.accept("./self.vue?vue&type=template&id=a8b23ef2&scoped=true&", function () {
      api.rerender('a8b23ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/self.vue"
export default component.exports